module.exports = __webpack_public_path__ + "static/media/a64.816663ce.jpg";